
import React, { useState, useEffect, useContext } from 'react';
import { addBusinessDays } from 'date-fns';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from 'react-icons/md';
import { FaSackDollar } from "react-icons/fa6";
import { IoMdCheckmark } from 'react-icons/io';
import { BsFillSendFill } from "react-icons/bs";
import { Layout, Header } from '../../../../components';
import { handleApi, formatCurrency, formatTwoDecimal,formatMediumDate } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ViewPayment = () => {
  const location = useLocation();
  const { inv } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [formattedPaymentMethods, setFormattedPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null); // The customer object
  const [installments, setInstallments] = useState([]);
  const [showPaymentButton, setShowPaymentButton] = useState(true);
  const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);
  const navigate = useNavigate();

  // Update isInstallment whenever pay changes
  // Update isInstallment when pay.amount or pay.inv.totalTaxedPrice changes
  const handleClose = () => { 
    navigate(-1);  // Navigate back when closing the form
  };
  const subtotal = inv?.totalUntaxedPrice || 0;
  const discountAmount = inv?.totalDiscount || 0;
  const subtotalAfterDiscount = subtotal - discountAmount;
  const taxAmount = inv?.totalTax || 0;;
  const grandTotal = subtotalAfterDiscount + taxAmount;

  // Format the values
  const formattedSubtotal = formatCurrency(subtotal.toFixed(2));
  const formattedDiscount = formatCurrency(discountAmount.toFixed(2));
  const formattedSubtotalAfterDiscount = formatCurrency(subtotalAfterDiscount.toFixed(2));
  const formattedTax = formatCurrency(taxAmount.toFixed(2));
  const formattedGrandTotal = formatCurrency(grandTotal.toFixed(2));
  const TransactionLineHeader = () => {
    return (
      <div className="grid grid-cols-6 gap-4 p-2 border-b rounded-lg w-full bg-gray-100 text-gray-800 font-semibold text-xs">
        <div className="col-span-2 text-left">Product</div>
        <div className="col-span-1 text-center">Price</div>
        <div className="col-span-1 text-center">Qty</div>
        <div className="col-span-1 text-center">Disc %</div>
        <div className="col-span-1 text-right">Total</div>
      </div>
    );
  };

 
 
  return (
    <Layout>
      <div className="m-4 bg-black rounded-xl shadow-2xl">
        <ToastContainer position="top-center" autoClose={2000} />

        {/* Header Section */}
        <div className="text-center  border-b">
          <div className="w-full flex justify-end">
            <button
              className="text-white hover:text-gray-300 py-1 px-2 rounded transition-all duration-300"
              title="Close"
              onClick={handleClose}
            >
              <MdOutlineCancel size={24} color={currentColor}/>
            </button>
          </div>
              
          <div className=" mx-4 text-white">
            <Header category="Purchases" title="View Invoice" color={currentColor}/>
          </div>
        </div>

        {/* Loading State */}
        {isLoading ? (
          <div className="flex flex-col items-center py-6">
            <Audio height="80" width="80" radius="9" color="white" ariaLabel="loading" />
            <p className="mt-4 text-white">Processing payment...</p>
          </div>
        ) : (
          <div>
          <div className="bg-white p-6 my-4 rounded-xl max-w-5xl mx-auto shadow-2xl grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Supplier Information Section */}
             {/* Payment Status and Date Section */}
            

            {/* supplier information */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800">
              <p className="text-lg text-center font-bold mb-2">Supplier Information</p>
              <div className="space-y-1">
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Supplier Name:</label>
                  <span>{inv?.partners?.name || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Contact Person:</label>
                  <span>{inv?.partners?.contact_person || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Phone:</label>
                  <span>{inv?.partners?.phone_number || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Email:</label>
                  <span>{inv?.partners?.email || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Invoice No:</label>
                  <span>{inv?.inv_no}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Date:</label>
                  <span>{formatMediumDate(inv?.date)}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Due Date:</label>
                  <span>{formatMediumDate(inv?.due_date)}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Order Reference:</label>
                  <span>{inv?.p_orders?.reference}</span>
                </div>
              </div>
            </div>
             {/* End Supplier Information Section */}

            {/* product Information Section */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800 text-xs">
              <p className="text-lg text-center font-bold mb-2">Product information</p>
              <div className="space-y-1">
                {/* Transaction lines */}
                <div className="bg-white rounded-lg shadow-md">
                  {inv.transactionLines?.length > 0 ? (
                    <>
                      <TransactionLineHeader />
                        {inv.transactionLines.map((line, index) => (
                          <div
                            key={index}
                            className={`grid grid-cols-6 p-1 border-b hover:bg-gray-100 ${index === inv.transactionLines.length - 1 ? 'border-b' : ''}`}
                          >
                          <div className="col-span-2 text-gray-700">{line.description || ''}</div>
                          <div className="col-span-1 text-center text-gray-600">{formatTwoDecimal(line.unit_price) || ''}</div>
                          <div className="col-span-1 text-center text-gray-600">{line.quantity || ''}</div>
                          <div className="col-span-1 text-center text-gray-600">{line.discount_percentage || 0}</div>
                          <div className="col-span-1 text-right text-gray-600">{formatTwoDecimal(line.lineDiscountedPriceInclusive) || ''}</div> 
                        </div>
                      ))}
                      {/* end transation */}          
                    </>
                  ) : (
                    <p className="p-6 text-center text-gray-500">No transactions found. Please ensure the selected inv has transactions.</p>
                  )}
                </div>
              </div>
            </div>
            {/* end product Information Section */}
            
            {/* Inmvoice  Information Section */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800 font-medium">
              <p className="text-lg text-center font-bold mb-2">Invoice Summary</p>
              <div className="space-y-1">
                <div className="flex justify-between text-sm">
                  <span>Subtotal:</span>
                  <span>{inv.totalPriceExclusive}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span>Discount:</span>
                  <span>{inv.totalDiscountExclusive}</span>
                </div>

                <div className="flex justify-between text-sm">
                  <span>Subtotal After Discount::</span>
                  <span>{inv.totalDiscountedPriceExclusive}</span>
                </div>

                <div className="flex justify-between text-sm">
                  <span>Tax:</span>
                  <span>{inv.totalTaxAfterDiscounted }</span>
                </div>

                <div className="flex justify-between text-sm">
                  <span>Grand Total:</span>
                  <span>{inv.totalDiscountedPriceInclusive}</span>
                </div>
              </div>
            </div>
            {/* End Invoice Summary  Section */}
            {/* Payment  information */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800">
              <p className="text-lg text-center font-bold mb-2">Payment Information</p>
              <div className="flex justify-between text-sm px-2">
                <label className="font-medium">Payment Status:</label>
                <span
                  className={`uppercase font-bold ml-2 ${
                    inv?.state === 'draft'
                    ? 'text-yellow-700'
                    : inv?.state === 'approved'
                    ? 'text-blue-600'
                    : inv?.state === 'cancelled'
                    ? 'text-red-600'
                    : inv?.state === 'deleted'
                    ? 'text-gray-400'
                    : inv?.state === 'paid'
                    ? 'text-green-600'
                    : 'text-yellow-500' // Default to yellow for 'Pending' or unassigned states
                  }`}
                >
                  {inv?.state || 'Pending'}
                </span>
              </div>
              <div className="flex justify-between text-sm px-2">
                  <span>Total Paid:</span>
                   <span className='font-bold'>{formatCurrency(inv?.totalPaidAmount|| 0)}</span>
                </div>
                <div className="flex justify-between text-sm px-2">
                  <span>Outstanding Balance:</span>
                  <span className='font-bold'>{formatCurrency(inv?.totalDiscountedPriceInclusive - inv?.totalPaidAmount || 0)}</span>
                </div>
                <label className='px-2 font-bold text-sm mt-3'>Payments Made:</label>
                <div className="overflow-x-auto">
                  {/* Render Table Header only if payments exist */}
                  {inv.payments.length > 0 && (
                    <div className="flex justify-between items-center py-1 px-4 bg-gray-200 rounded-t-lg">
                      {/* Payment Information Header */}
                      <div className="flex flex-col w-1/3">
                        <span className="text-sm font-medium text-gray-800">Date</span>
                      </div>

                      {/* Payment Method Header */}
                      <div className="flex flex-col w-1/3">
                        <span className="text-sm font-medium text-gray-800">Method</span>
                      </div>

                      {/* Payment Amount Header */}
                      <div className="flex flex-col text-right w-1/3">
                        <span className="text-sm font-medium text-gray-800">Amount</span>
                      </div>

                      {/* Payment Status Header */}
                      <div className="flex flex-col text-right w-1/3">
                        <span className="text-sm font-medium text-gray-800">Status</span>
                      </div>
                      
                    </div>
                  )}

                  {/* Render Payment Records */}
                  {inv.payments.length ? (
                    inv.payments.map((payment, index) => (
                      <div key={index} className="flex justify-between items-center px-4 py-1 bg-gray-100 rounded-lg hover:shadow-lg transition-all duration-300">
                        {/* date */}
                        <div className="flex flex-col w-1/3">
                          <span className="text-xs text-gray-500">{formatMediumDate(payment?.date)}</span>
                        </div>

                        {/* Payment Method */}
                        <div className="flex flex-col w-1/3">
                          <span className="text-xs text-gray-500 capitalize">
                            {paymentMethods.find(method => method.id === payment?.method_id)?.name || "N/A"}
                          </span>
                        </div>

                        {/* Payment Amount */}
                        <div className="flex flex-col text-right w-1/3">
                          <span className="text-xs text-gray-500">{formatCurrency(payment?.amount)}</span>
                        </div>

                        {/* Payment Amount */}
                        <div className="flex flex-col text-right w-1/3">
                          <span className="text-xs text-gray-500 capitalize">{payment?.state}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-gray-500">No past payments found</div>
                  )}
                </div>
                {/* end Payments list */}
                

                
            </div>

            <div className="flex justify-end ">
                        <button
                          onClick={handleClose}
                          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                        >
                          <MdOutlineCancel size={20} />
                          <span>Close</span>
                        </button>
                      </div> 
            </div>
            
             {/* End Payment Information Section */}

            {/* Product Information Section */}
                        
            {/* End product Information Section */}
            {/* Payment Information Section */}
            {/* close Buttons */}
                      
          </div>
        )}
        
      </div>
    </Layout>
  );
};
export default ViewPayment;
